"use client";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Render-prop wrapper around dnd-kit's useSortable — keeps the drag wiring in
// one place while letting each item panel (Role/Project/Education) render its
// own markup with the sortable ref/style/listeners spread in.
export default function SortableItem({ id, children }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1 : "auto",
  };

  return children({ setNodeRef, style, attributes, listeners });
}
